(() => {
  'use strict';
  if (window.WubsAIProducts) return;
  const config = document.querySelector('[data-wubs-ai-products-config]');
  const cache = new Map();
  const section = 'wubs-ai-product-card';
  const root = () => window.Shopify?.routes?.root || '/';
  const storeHosts = new Set(['quicktest.se', 'quicktest.no', 'quicktest.dk', 'quicktest.fi', 'quicktest.eu', 'quicktest-sverige.myshopify.com', window.location.hostname]);
  const productPath = (source) => {
    let handle = source.handle || '';
    const value = source.product_url || source.url;
    if (value) {
      let url;
      try { url = new URL(String(value), window.location.origin); } catch (_) { return null; }
      if (!['http:', 'https:'].includes(url.protocol) || !storeHosts.has(url.hostname.replace(/^www\./, ''))) return null;
      const match = url.pathname.match(/\/products\/([a-z0-9][a-z0-9-]*)\/?$/i);
      if (!match) return null;
      handle = match[1];
    }
    if (!/^[a-z0-9][a-z0-9-]*$/i.test(handle)) return null;
    return `${root()}products/${encodeURIComponent(handle)}`;
  };
  const safeImage = (value) => {
    try { const url = new URL(String(value), window.location.origin); return ['https:', 'http:'].includes(url.protocol) ? url.href : ''; } catch (_) { return ''; }
  };
  const loadCard = (path) => {
    const url = new URL(path, window.location.origin);
    url.searchParams.set('section_id', section);
    const preview = new URLSearchParams(window.location.search).get('preview_theme_id');
    if (/^\d+$/.test(preview || '')) url.searchParams.set('preview_theme_id', preview);
    const key = url.href;
    if (cache.has(key)) return cache.get(key);
    const controller = new AbortController();
    const timeout = window.setTimeout(() => controller.abort(), 8000);
    const request = fetch(key, {credentials: 'same-origin', signal: controller.signal})
      .then(async response => {
        if (!response.ok) throw new Error('Card unavailable');
        const finalUrl = new URL(response.url || key, window.location.origin);
        if (finalUrl.origin !== window.location.origin) throw new Error('Unexpected market redirect');
        const finalHandle = finalUrl.pathname.match(/\/products\/([a-z0-9][a-z0-9-]*)\/?$/i)?.[1];
        return {html: await response.text(), finalHandle};
      })
      .then(({html, finalHandle}) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const card = doc.querySelector('[data-wubs-ai-product]');
        if (!card || card.dataset.productHandle !== finalHandle) throw new Error('Missing product card');
        card.querySelectorAll('script').forEach(script => script.remove());
        return card;
      })
      .catch(error => { cache.delete(key); throw error; })
      .finally(() => window.clearTimeout(timeout));
    if (cache.size >= 32) cache.delete(cache.keys().next().value);
    cache.set(key, request);
    return request;
  };
  const trackLinks = (card, id) => {
    card.querySelectorAll('[data-wubs-ai-product-link], [data-wubs-ai-add]').forEach(link => {
      link.setAttribute('data-qt-card', '');
      link.setAttribute('data-qt-pid', String(id || card.dataset.productId || ''));
    });
  };
  const create = (source, options = {}) => {
    const path = productPath(source);
    if (!path) return null;
    const card = document.createElement('article');
    card.className = 'wubs-aip';
    const title = String(source.title || source.label || '');
    const imageLink = document.createElement('a');
    imageLink.className = 'wubs-aip__image'; imageLink.href = path; imageLink.setAttribute('aria-label', title); imageLink.setAttribute('data-wubs-ai-product-link', '');
    const imageUrl = safeImage(source.image_url || source.imageUrl || source.image?.url || source.image?.src || source.featuredImage?.url || source.featured_image?.url || '');
    if (imageUrl) {
      const image = document.createElement('img'); image.src = imageUrl; image.alt = ''; image.loading = 'lazy'; image.decoding = 'async'; imageLink.append(image);
    }
    const body = document.createElement('div'); body.className = 'wubs-aip__body';
    const name = document.createElement('a'); name.href = path; name.className = 'wubs-aip__title'; name.textContent = title; name.setAttribute('data-wubs-ai-product-link', '');
    const bottom = document.createElement('div'); bottom.className = 'wubs-aip__bottom';
    const details = document.createElement('a'); details.href = path; details.className = 'wubs-aip__button'; details.textContent = config?.dataset.viewProduct || ''; details.setAttribute('data-wubs-ai-product-link', '');
    bottom.append(details); body.append(name, bottom); card.append(imageLink, body);
    if (options.tracked) trackLinks(card, source.product_id);
    loadCard(path).then(rendered => {
      if (!card.isConnected) return;
      const expectedId = String(source.product_id || source.productId || '').replace(/^gid:\/\/shopify\/Product\//, '');
      if (/^\d+$/.test(expectedId) && rendered.dataset.productId !== expectedId) return;
      const copy = rendered.cloneNode(true);
      // The Shopify card provides all commerce data; no model HTML is inserted.
      card.dataset.productId = copy.dataset.productId;
      card.dataset.productHandle = copy.dataset.productHandle;
      card.replaceChildren(...Array.from(copy.childNodes));
      if (options.showReason && source.reason) {
        let description = card.querySelector('.wubs-aip__description');
        if (!description) {
          description = document.createElement('p'); description.className = 'wubs-aip__description';
          card.querySelector('.wubs-aip__title')?.after(description);
        }
        description.textContent = String(source.reason);
      }
      if (options.tracked) trackLinks(card, card.dataset.productId);
      if (options.onReady) window.requestAnimationFrame(options.onReady);
    }).catch(() => { /* A valid product-details link remains usable on timeout/404. */ })
      .finally(() => options.onSettled?.());
    return card;
  };
  let cartBusy = false;
  document.addEventListener('click', async event => {
    const button = event.target.closest?.('[data-wubs-ai-add]');
    if (!button) return;
    event.preventDefault();
    if (cartBusy || button.disabled || !/^\d+$/.test(button.dataset.wubsAiAdd || '')) return;
    const card = button.closest('.wubs-aip');
    const error = card?.querySelector('.wubs-aip__error');
    if (error) { error.hidden = true; error.textContent = ''; }
    cartBusy = true; button.disabled = true; button.setAttribute('aria-busy', 'true');
    const controller = new AbortController();
    const timeout = window.setTimeout(() => controller.abort(), 30000);
    try {
      const response = await fetch(`${root()}cart/add.js`, {method: 'POST', credentials: 'same-origin', signal: controller.signal, headers: {'Content-Type': 'application/json', Accept: 'application/json'}, body: JSON.stringify({id: button.dataset.wubsAiAdd, quantity: 1})});
      const item = await response.json();
      if (!response.ok) throw new Error(String(item.description || item.message || button.dataset.cartError));
      const drawer = window.WubsCartDrawer;
      if (typeof drawer?.open === 'function') drawer.open();
      else if (typeof window.wubsCartDrawerOpen?.main === 'function') window.wubsCartDrawerOpen.main();
      else window.location.assign(`${root()}cart`);
      document.dispatchEvent(new CustomEvent('wubs:ai-cart-added', {detail: {item}}));
    } catch (failure) {
      if (error) { error.textContent = failure.name === 'AbortError' ? button.dataset.cartError : (failure.message || button.dataset.cartError); error.hidden = false; }
    } finally {
      window.clearTimeout(timeout);
      cartBusy = false; button.disabled = false; button.removeAttribute('aria-busy');
    }
  });
  window.WubsAIProducts = {create, productPath};
})();
